import base from "../baseurl";
import token from "../getTk";

const showAll = async () => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });

  const show = await api
    .post("company-form-questions/showall", {
      json: {},
    })
    .json();
  return show;
};

export default showAll;
